import { EditorState } from 'draft-js';
import { observable, action } from 'mobx';
import { FontColor, Background } from '../../components/styles/FontStyle'
import { Strategy } from '../../components/strategy/Strategy'
export default class EditorStore {

    @observable editorState
    @observable fontColor = { ...FontColor }
    @observable backgroundColor = { ...Background }
    @observable fontStyle = null
    @observable fontInlineStyle = {}
    @observable fontSize = null
    @observable readOnly = false
    @observable toolbar = false
    @observable isMobile = false//textarea 전용이므로 삭제될 예정
    @observable isApp = true
    @observable isLoading = false
    @observable isPC = false

    constructor(root) {
        this.root = root;
        this.editorState = EditorState.createEmpty(Strategy)
        this.fontColor = { ...FontColor }
        this.backgroundColor = { ...Background }
    }

    @action setEditorState = obj => {
        this.editorState = obj
    }

    @action setEditorStateWithContent = (content) =>{
        this.editorState = EditorState.createWithContent(content, Strategy)
    }

    @action setFontColor = (val) => {
        var temp = JSON.parse(JSON.stringify(this.fontColor))
        temp[val] = {color:val}
        this.fontColor = { ...this.fontColor, ...temp }
    }

    @action setBackgroundColor = (val) => {
        var temp = JSON.parse(JSON.stringify(this.backgroundColor))
        temp[val] = { background: val }
        this.backgroundColor = { ...this.backgroundColor, ...temp }
    }

    @action setReadOnly = val => {
        this.readOnly = val
    }
    
    @action setToolbar = val => {
        this.toolbar = val
    }

    @action setIsMobile = val => {
        this.isMobile = val
    }

    @action setIsApp = val => {
        this.isApp = val
    }

    @action setIsLoading = val => {
        this.isLoading = val
    }

    @action setIsPC = val => {
        this.isPC = val
    }

    @action setFontStyle = val => {
        this.fontStyle = val
    }

    @action setFontSize = val => {
        this.fontSize = val
    }
    
    @action setFontInlineStyle = val => {
        this.fontInlineStyle = val
    }
}